import { useMutation, useQueryClient } from '@tanstack/react-query';

import { request } from '../utils/api'; // your axios wrapper
import { resetApplicationSession } from '../utils/reactQuery';

export type LoginPayload = {
  email: string;
  password: string;
};

export type LoginResponse = {
  data: {
    token: string;
    user?: any;
  };
}

export function login(payload: LoginPayload) {
  return request<LoginResponse>({
    method: 'POST',
    url: '/auth/login',
    data: payload,
  });
}


export function useLogin() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: LoginPayload) => login(payload),
    onSuccess: () => {
      resetApplicationSession(queryClient);
    },
  });
}
